import { withMainControls } from '@eventbrite/eds-structure';
import { getCanonicalSearchUrl } from '@eventbrite/redux-destination';
import * as analytics from '@eventbrite/site-analytics';
import { $FixMe } from '@eventbrite/ts-utils';
import React, { FunctionComponent } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { useMount } from 'react-use';
import { compose } from 'redux';
import {
    handleApplyFilter as handleApplyFilterAction,
    handleApplyFilterSimple as handleApplyFilterSimpleAction,
    searchEventSuggestions as searchEventSuggestionsAction,
} from '../../../../redux/actions/search';
import { DiscoverState } from '../../../../types';
import { addSearchIdToGaAction } from '../../utils/analytics';
import { LowResults, NoResults } from './components/EmptyState';
import {
    EventSuggestions,
    FilterSuggestions,
    TagSuggestions,
} from './components/Suggestions';
import { GA_SEARCH_REDIRECTION_CATEGORY } from './constants';
import {
    getEventSuggestions,
    getParsedSuggestedFilters,
    getRandomizedSuggestedTags,
    getTrendingSearchData,
} from './selectors';

export type SearchPivotSuggestionsProps = {
    isLoading: boolean;
    hasEventResults: boolean;
    isNextDisabled: boolean;
};

// These types are not accurate
type SearchPivotSuggestionsReduxProps = {
    currentPlace?: string;
    isOnlineSearch?: boolean;
    isOrganizationsSearch?: number;
    trackGAEvent?: Function;
};

const SearchPivotSuggestions = (
    props: SearchPivotSuggestionsProps & SearchPivotSuggestionsReduxProps,
) => {
    const {
        trackGAEvent,
        hasEventResults,
        isOrganizationsSearch,
        isOnlineSearch,
        currentPlace,
    } = props;

    //TODO: trigger this on scroll into view as opposed to on mount
    useMount(() => {
        trackGAEvent?.({
            action: 'EndResultsSectionShown',
            nonInteraction: true,
        });
    });

    return (
        <>
            <section className="search-result-pivots__empty-state">
                {hasEventResults ? (
                    <LowResults containerClassname="eds-l-pad-hor-6" />
                ) : (
                    <NoResults
                        containerClassname="eds-l-pad-hor-6"
                        isOrganizationsSearch={isOrganizationsSearch}
                        isOnlineSearch={isOnlineSearch}
                        currentPlace={currentPlace}
                    />
                )}
            </section>
            <EventSuggestions {...props} />
            <TagSuggestions {...props} />
            <FilterSuggestions {...props} />
        </>
    );
};

const _mapStateToProps = (state: DiscoverState) => ({
    featureFlags: state.app.featureFlags,
    suggestionsLoading: state.suggestions.loading,
    eventSuggestions: getEventSuggestions(state),
    suggestedFilters: getParsedSuggestedFilters(state),
    suggestedTags: getRandomizedSuggestedTags(state),
    isAuthenticated: state.auth.isAuthenticated,
    shareOptions: state.share?.options,
    locale: state.app.locale,
    allEventsUrl: getCanonicalSearchUrl({ slug: state.location.slug }),
    trackGAEvent: (action: any) =>
        analytics.trackEventFromState(
            state,
            addSearchIdToGaAction(
                { ...action, category: GA_SEARCH_REDIRECTION_CATEGORY },
                state,
            ),
        ),
    trackGAEventOnPageUnload: (action: any) =>
        analytics.trackEventFromStateOnPageUnload(
            state,
            addSearchIdToGaAction(
                {
                    ...action,
                    category: GA_SEARCH_REDIRECTION_CATEGORY,
                },
                state,
            ),
        ),
    trendingSearchData: getTrendingSearchData(
        state.location,
        state.app.domain,
        state.shouldShowTrendingSearchPageLink,
    ),
    isOnlineSearch: state.location.slug == 'online',
    currentPlace: state.location.currentPlace,
    bbox: state.search.eventSearch.bbox,
    isOrganizationsSearch:
        state.search.eventSearch.organizationsOr?.length || 0,
});

const _mapDispatchToProps = (dispatch: Function, ownProps: any) => ({
    handleApplyFilter: (...args: [$FixMe]) =>
        dispatch(handleApplyFilterAction(ownProps.history, ...args)),
    handleApplyFilterSimple: (...args: [$FixMe]) =>
        dispatch(handleApplyFilterSimpleAction(ownProps.history, ...args)),
    searchEventSuggestionsAction: (...args: any) =>
        dispatch(searchEventSuggestionsAction(...args)),
});

export default compose(
    withMainControls,
    withRouter,
    connect(_mapStateToProps, _mapDispatchToProps),
)(SearchPivotSuggestions) as FunctionComponent<SearchPivotSuggestionsProps>;
